(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGORender"), require("FEGOWebapi"), require("VueDemi"), require("FEGOBridge"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGORender", "FEGOWebapi", "VueDemi", "FEGOBridge"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/top-container/render"] = factory(require("FEGORender"), require("FEGOWebapi"), require("VueDemi"), require("FEGOBridge"));
	else
		root["/fego/component/top-container/render"] = factory(root["FEGORender"], root["FEGOWebapi"], root["VueDemi"], root["FEGOBridge"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__5113__, __WEBPACK_EXTERNAL_MODULE__2309__, __WEBPACK_EXTERNAL_MODULE__7145__) => {
return 